import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BannerTemplateLibrary = lazy(() =>
  import("@scenes/MessageComposition/Banner/BannerTemplateLibrary").then((module) => ({
    default: module.BannerTemplateLibrary,
  }))
);

export const bannerTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  Component: BannerTemplateLibrary,
  // This feature does not have non-NRO flow so we don't need to check for the NRO component feature flipper.
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("banner-templates-nro-heading", "Banner Templates"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("banner-templates-nro-description", "Manage the templates of banner campaigns"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("banners") && featureOn("banners_template_library");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
